import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap';

import { connect } from 'react-redux';

import { scrollToRef } from 'helpers/scrolling';

export function DealFormErrors({ errors }) {
  const ref = useRef();

  useEffect(() => {
    if (errors) {
      scrollToRef(ref);
    }
  }, [errors]);

  if (!errors) {
    return null;
  }

  return (
    <Alert bsStyle="warning" className="mb-0">
      <h4 ref={ref}><strong>Whoops -</strong> There were errors in the form that prevented saving.</h4>
      <ul>
        {errors.map((error, i) => <li key={i}>{error}</li>)}
      </ul>
    </Alert>
  );
}

DealFormErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = state => ({
  errors: state.deal.errors,
});

export default connect(mapStateToProps)(DealFormErrors);
